import React from "react";
import BasicHeader from "@components/BasicHeader";
import BasicFooter from "@components/BasicFooter";
import Layout from "@components/Layout";
import Head from "next/head";

export default function DeleteAccount() {
  return (
    <Layout title="Snacktime - Delete Account Instructions">
      <Head>
        <meta
          property="og:url"
          content={process.env.NEXT_PUBLIC_SNACKTIME_PUBLIC_WEB_URL}
          key="ogurl"
        />
        <meta property="og:site_name" content="Snacktime" key="ogsitename" />
        <meta
          property="og:image"
          content={`${process.env.NEXT_PUBLIC_SNACKTIME_PUBLIC_WEB_URL}/Snacktime-app-icon-1024x1024.png`}
          key="ogimage"
        />
        <meta
          property="og:title"
          content="Snacktime - Terms of Service"
          key="ogsitename"
        />
        <meta property="og:type" content="website" key="ogtype" />
        <meta
          property="og:description"
          content="Grab a cup of coffee and carefully read the following
              pages. It will take you approximately 20 minutes."
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:site"
          content={process.env.NEXT_PUBLIC_SNACKTIME_TWITTER_USERNAME}
        />
        <meta name="twitter:title" content="Snacktime - Terms of Service" />
        <meta
          name="twitter:description"
          content="Grab a cup of coffee and carefully read the following
              pages. It will take you approximately 20 minutes."
        />
        <meta
          name="twitter:image"
          content={`${process.env.NEXT_PUBLIC_SNACKTIME_PUBLIC_WEB_URL}/Snacktime-app-icon-1024x1024.png`}
        />
        <meta
          property="twitter:image:alt"
          content="Snacktime - photos, videos, and luck"
        />
        <meta
          property="fb:app_id"
          content={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
        />
      </Head>
      <BasicHeader />
      <div className="flex justify-center px-4 sm:block sm:px-0 sm:container sm:mx-auto w-screen">
        <div className="flex flex-col ">
          <h1 className="text-2xl lg:text-3xl py-8">
            Instructions to delete your Snacktime account
          </h1>

          <h2 className="text-md">
            Please follow these steps to permanently delete your Snacktime
            account and data.
          </h2>

          <ol className="list-decimal w-full pl-4 py-6">
            <li className="py-1">
              Sign-in to the Snacktime app (iOS or Android)
            </li>
            <li className="py-1">Tap the Account button (lower right)</li>
            <li className="py-1">Tap the Settings button (upper right)</li>
            <li className="py-1">Tap the Profile button</li>
            <li className="py-1">
              Tap the Delete Account button and follow the prompts
            </li>
          </ol>
        </div>
      </div>

      <BasicFooter />
    </Layout>
  );
}
